import React, { useMemo } from 'react';
import Modal from 'components/Layout/Modal';
import Table from 'components/Layout/Table';
import { getDataFromLocalStorage } from 'utils/helpers';

const RaisedRequestModal = ({ onHide, data = [] }) => {
  const userData = getDataFromLocalStorage();

  const header = useMemo(
    () => [
      { title: 'Categories' },
      { title: 'Free Membership' },
      { title: 'Premium Membership' },
    ],
    []
  );

  const rowData = useMemo(
    () =>
      data?.service_data?.map(({ category, free_member, premium_member }) => ({
        data: [
          {
            value: (
              <span className="color-new-car text-14-300-18">
                {category}
              </span>
            ),
          },
          { value: <div className="text-nowrap text-14-300-18">₹{free_member}</div> },
          { value: <div className="text-nowrap text-14-300-18">₹{premium_member}</div> },
        ],
      })) || [],
    [data]
  );

  const renderRequestStatus = () => {
    const { request_status } = data || {};
    const isUserType6 = userData?.user_type === '6';

    const statusMessages = {
      1: isUserType6
        ? 'Your request has been accepted.'
        : 'You have accepted this request.',
      2: isUserType6
        ? 'Your request has been rejected.'
        : 'You have rejected this request.',
    };

    const statusClass = {
      1: 'color-success',
      2: 'color-danger-bar',
    };

    return request_status ? (
      <div className={`cms-27 cmt-5 cmb-5 ${statusClass[request_status]}`}>
        {statusMessages[request_status]}
      </div>
    ) : null;
  };

  return (
    <Modal
      onHide={onHide}
      titleBesideClose={data?.event_name}
      isTitleBorder
      isTitleVerticalCenter
      titleBesideCloseClassName={'text-16-300-20'}
    >
      <div className="cms-27 cme-27 cmb-19 cmt-19">
        <Table
          header={header}
          rowData={rowData}
          hidePagination
          customHeaderStyle={{
            backgroundColor: '#2148C0',
            color: 'white',
            height: '45px',
          }}
        />
      </div>
      {renderRequestStatus()}
    </Modal>
  );
};

export default RaisedRequestModal;
